import {
    ReservationSwitch,
    ReservationSwitchProps,
} from '@app/components/molecules/reservation-switch';
import {
    CreateFilterItemsProps,
    FilterGroup,
    handleMultipleCheckboxGroupValueChange,
} from '@app/components/organisms/filter-items';
import { FILTER_KEYS } from '@app/consts/search-filters.consts';
import { ReservationFeaturesEnum } from '@app/enums';

import { FILTER_CREATORS } from './filter-creators';

export const createFilterItems = ({
    availableOptions,
    localFilters,
    onFilterChange,
    withCounter,
}: CreateFilterItemsProps): FilterGroup[] => {
    const filters = availableOptions?.filters;

    if (!filters?.length) {
        return [];
    }

    return filters
        .map(filter =>
            FILTER_CREATORS[filter.key]?.({
                availableFilter: filter,
                filters: localFilters,
                onFilterChange,
            }),
        )
        .filter(filterGroup => !!filterGroup)
        .map(group => ({ ...group, availableOptions, withCounter }));
};

export const createReservationSwitchWithConfig = ({
    config,
    localFilters,
    onFilterChange,
}: CreateFilterItemsProps & {
    config: ReservationSwitchProps;
}) => {
    const { switchProps, ...props } = config;

    return (
        <ReservationSwitch
            {...props}
            switchProps={{
                ...switchProps,
                checked: localFilters?.reservationFeatures?.includes(
                    ReservationFeaturesEnum.RealtimeBookingModel,
                ),
                value: ReservationFeaturesEnum.RealtimeBookingModel,
                onCheckedChange: details => {
                    handleMultipleCheckboxGroupValueChange(
                        FILTER_KEYS.RESERVATION_FEATURES,
                        localFilters.reservationFeatures,
                        ReservationFeaturesEnum.RealtimeBookingModel,
                        details.checked,
                        onFilterChange,
                    );
                },
            }}
        />
    );
};
